import React, { useState, useEffect } from "react";
import SlidingPane from "react-sliding-pane";
import axios from "axios";
import Helper from "../../../../Helper";
import { API } from "../../../../backend";
import authHeader from "../../../../services/auth-header";
import Form from "react-validation/build/form";
import { getTrans as t } from "../../../../Localization/translations";
import { useForm } from "react-hook-form";
import ContractPaymentDetails from "../Paymentdetails/ViewPaymentDetail/PaymentDetailview";
import Tooltip from "@tippyjs/react";
import "tippy.js/dist/tippy.css";
import MaterialTable from "material-table";
  import { useRef } from "react";

export default function PaymentChangePane({
  isOpen,
  onClose,
  contractId,
  contractdetails,
  onSave,
  onPaymentDetailsChange
}) {
  const [rowsData, setRowsData] = useState([]);
  const [paymentDetails, setPaymentDetails] = useState([]);
  const [paymentType, setPaymentType] = useState([]);
  const [termError, setTermError] = useState("");

  const [feedefination, setFeeDefination] = useState([]);

  const [calcSchedule, setCalcSchedule] = useState([]);
 
  const [paymentDetailsList, setPaymentDetailsList] = useState([]);
  
  const [mergedPaymentDetails, setMergedPaymentDetails] = useState([]);
  const [frequencyMapped, setFrequencyMapped] = useState({
    Monthly: 1,
    Quarterly: 3,
    SemiAnnual: 6,
    Annual: 12,
  });
  const [paymentrule, setPaymentRule] = useState(contractdetails.paymentrule);
  const [paymentfrequency, setPaymentFrequency] = useState(contractdetails.paymentfrequency);
  const [itemsPayment, setItemsPayment] = useState([]);
  const [itemsPaymentParent, setItemsPaymentParent] = useState([]);
  const [draftid, setDraftid] = useState(null);

  const FeeDefination = () => {
    let url = API + "expenses/fee-types/";
    axios.get(url, { headers: authHeader() }).then((response) => {
      setFeeDefination(response.data);
      setPaymentType(response.data);
    });
  };

  useEffect(() => {
    FeeDefination();
  }, []);

  // frequency options
  const paymentFrequencystep = [
    { value: 1, label: "Monthly" },
    { value: 3, label: "Quarterly" },
    { value: 6, label: "Semi-annual" },
    { value: 12, label: "Annual" },
  ];

  const loadVersionPaymentSchedule = async (versionContractId) => {
    const res = await axios.get(
      `${API}contracts/payment-view/${versionContractId}/`,
      { headers: authHeader() }
    );
    // Here res.data = ALL rows for version 2
    // Already includes billed (is_historical = true) and editable
    const cleanRows = cleanVersionRows(res.data);
    setRowsData(cleanRows);
  };

  const cleanVersionRows = (rows) => {
    if (!rows || rows.length === 0) return [];

    const cleaned = rows.map((row) => {
      // strip time ("2025-08-01 00:00:00" → "2025-08-01")
      const cleanDate = (dt) => {
        if (!dt) return "";
        return dt.split(" ")[0];
      };

      return {
        ...row,
        start_date: cleanDate(row.start_date),
        end_date: cleanDate(row.end_date),
        paymentstart_date: cleanDate(row.paymentstart_date),
        billed: row.is_historical === true,
        disabled: row.is_historical === true,
      };
    });

    // Now fix invalid / overlapping dates
    return fixVersionChain(cleaned);
  };

  const fixVersionChain = (rows) => {
    const updated = [...rows];

    for (let i = 0; i < updated.length; i++) {
      const row = updated[i];

      // skip locked rows completely
      if (row.disabled) continue;

      // find start date
      let start;
      if (i === 0) {
        start = new Date(updated[0].start_date);
      } else {
        const prevEnd = new Date(updated[i - 1].end_date);
        prevEnd.setDate(prevEnd.getDate() + 1);
        start = prevEnd;
      }

      // frequency to months
      const freqMap = {
        Monthly: 1,
        Quarterly: 3,
        "Semi-annual": 6,
        Annual: 12,
      };

      const monthsToAdd =
        (row.no_of_payments || 0) * (freqMap[row.frequency] || 1);

      // calc end date
      const end = new Date(start);
      end.setMonth(end.getMonth() + monthsToAdd);
      end.setDate(end.getDate() - 1);

      row.start_date = Helper.DatePicker(start);
      row.end_date = Helper.DatePicker(end);
      row.paymentstart_date = Helper.DatePicker(start);
    }

    return updated;
  };

  const handlePaymentTypeChange = (index, event) => {
    const updatedRowsData = [...rowsData];
    updatedRowsData[index].payment_frequency = paymentfrequency;

    const isOneTimeFee = paymentType.some(
      (pt) => pt.value === event && pt.fee_nature === "One Time"
    );
    if (isOneTimeFee) {
      const paymentTypeExists = updatedRowsData.some(
        (row, idx) => row.payment_type === event && idx !== index
      );

      if (paymentTypeExists) {
        setTermError(`${event} can only have one entry.`);
        return;
      }
    }
    updatedRowsData[index].payment_type = event;

    if (isOneTimeFee) {
      const contractTerm =
        contractdetails.contract_term / frequencyMapped.Monthly;
      let startDate = new Date(contractdetails.start_date);
      let paymentstartDate;

      if (paymentrule === "Advance") {
        paymentstartDate = new Date(contractdetails.start_date);
      } else {
        paymentstartDate = new Date(contractdetails.paymentstartdate);
      }
      let endDate = new Date(startDate);
      // const month = frequencyMapped.Annual * contractTerm;
      if (paymentfrequency === "Monthly") {
        endDate.setMonth(endDate.getMonth() + frequencyMapped.Monthly);
        endDate.setDate(endDate.getDate() - 1);
        updatedRowsData[index].no_of_payments = 1;
        updatedRowsData[index].start_date = Helper.DatePicker(startDate);
        updatedRowsData[index].end_date = Helper.DatePicker(endDate);
        updatedRowsData[index].payment_frequency = paymentfrequency;
        updatedRowsData[index].paymentstart_date =
          Helper.DatePicker(paymentstartDate);
      } else if (paymentfrequency === "Quarterly") {
        endDate.setMonth(endDate.getMonth() + frequencyMapped.Quarterly);
        endDate.setDate(endDate.getDate() - 1);
        updatedRowsData[index].no_of_payments = 1;
        updatedRowsData[index].start_date = Helper.DatePicker(startDate);
        updatedRowsData[index].end_date = Helper.DatePicker(endDate);
        updatedRowsData[index].payment_frequency = paymentfrequency;
        updatedRowsData[index].paymentstart_date =
          Helper.DatePicker(paymentstartDate);
      } else if (paymentfrequency === "Semi-annual") {
        endDate.setMonth(endDate.getMonth() + frequencyMapped.SemiAnnual);
        endDate.setDate(endDate.getDate() - 1);
        updatedRowsData[index].no_of_payments = 1;
        updatedRowsData[index].start_date = Helper.DatePicker(startDate);
        updatedRowsData[index].end_date = Helper.DatePicker(endDate);
        updatedRowsData[index].payment_frequency = paymentfrequency;
        updatedRowsData[index].paymentstart_date =
          Helper.DatePicker(paymentstartDate);
      } else if (paymentfrequency === "Annual") {
        endDate.setMonth(endDate.getMonth() + frequencyMapped.Annual);
        endDate.setDate(endDate.getDate() - 1);
        updatedRowsData[index].no_of_payments = 1;
        updatedRowsData[index].start_date = Helper.DatePicker(startDate);
        updatedRowsData[index].end_date = Helper.DatePicker(endDate);
        updatedRowsData[index].payment_frequency = paymentfrequency;
        updatedRowsData[index].paymentstart_date =
          Helper.DatePicker(paymentstartDate);
      }
    } else if (event === "Rent") {
      updatedRowsData[index].payment_frequency = paymentfrequency;
    } else {
      updatedRowsData[index].payment_frequency = paymentfrequency;
    }

    setRowsData(updatedRowsData);
  };

  const loadOriginalPaymentDetails = async () => {
    const res = await axios.get(
      `${API}contracts/paymentDetail-view/${contractId}/`,
      { headers: authHeader() }
    );

    const built = buildEditablePaymentRows(res.data); // your grouping logic
    setRowsData(built);
  };


  useEffect(() => {
    // if (!isOpen) return;
    axios
      .get(`${API}contracts/contracts/${contractId}/versions/`, {
        headers: authHeader(),
      })
      .then((res) => {
        const versions = res.data.versions || [];

      // 🔥 pick latest ContractMod version
      const pending = versions
        .filter(v => v.status === "ContractMod")
        .sort((a, b) => b.version - a.version)[0];

      if (pending) {
        setDraftid(pending.id);

        // load payment schedule for draft
        loadVersionPaymentSchedule(pending.id);
      } else {
        setDraftid(null);

        // fallback → original contract
        loadOriginalPaymentDetails();
      }
    })
    .catch(err => {
      console.error("Failed to load versions", err);
    });
        // const pending = res.data.versions.find(v => v.status === "PendingApproval");
      //   const pending = res.data.versions.find(
      //     (v) => v.status === "ContractMod"
      //   );
      //   setDraftid(pending ? pending.id : null);

      //   if (pending) {
      //     // Version already exists → load version-2 schedule
      //     loadVersionPaymentSchedule(pending.id);
      //   } else {
      //     // No version exists → use original PaymentDetails
      //     loadOriginalPaymentDetails();
      //   }
      // });

    // if (isOpen) {
    //   loadPaymentSchedule();
    //   // load payment types if needed
    //   // axios.get(API + "fees/", { headers: authHeader() }).then(r => setPaymentType(r.data)).catch(()=>{});
    // }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [onClose]);

  const buildEditablePaymentRows = (details) => {

    // 1. Identify billed & unbilled
    const billed = details.filter((r) => r.date_billed);
    const unbilled = details.filter((r) => !r.date_billed);

    const rows = [];

    // ======= 2. Collapse all billed into ONE row =======
    if (billed.length > 0) {
      rows.push({
        payment_type: billed[0].paymenttype,
        amount: billed[0].periodicamount,
        payment_frequency: contractdetails?.payment_frequency,
        no_of_payments: billed.length,
        start_date: billed[0].startdate,
        end_date: billed[billed.length - 1].enddate,
        disabled: true,
        billed: true,
      });
    }

    // ======= 3. Collapse unbilled into one row =======
    if (unbilled.length > 0) {
      rows.push({
        payment_type: unbilled[0].paymenttype,
        amount: unbilled[0].periodicamount,
        payment_frequency: contractdetails?.payment_frequency,
        no_of_payments: unbilled.length,
        start_date: unbilled[0].startdate,
        end_date: unbilled[unbilled.length - 1].enddate,
        disabled: false,
        billed: false,
      });
    }
    return rows;
  };


  const handelDefault = () => {
    let url = API + `contracts/contracts/${contractId}/payment-schedule/`;
    axios
      .get(url, { headers: authHeader() })
      .then((response) => {setItemsPayment(response.data.parent_contract.payment_schedules)
         const data = response.data; // this is an array

      // find only ContractMod contract
      const contractMod = data.child_contracts.find(
        (item) => item.status === "ContractMod"
      );
      if (contractMod) {
        setItemsPaymentParent(contractMod.payment_schedules);
      } else {
        setItemsPaymentParent([]);
      }
        // setItemsPaymentParent(response.data.child_contracts.payment_schedules);
  });
  };

  useEffect(() => {
    handelDefault();
  }, [onClose]);

  // const loadPaymentSchedule = async () => {
  //   if (!contractId) return;
  //   try {
  //     const res = await axios.get(
  //       `${API}contracts/paymentDetail-view/${contractId}/`,
  //       { headers: authHeader() }
  //     );
  //     const details = res.data || [];
  //     setPaymentDetails(details);
  //     const built = buildEditablePaymentRows(details);
  //     setRowsData(built);
  //   } catch (err) {
  //     console.error("Error loading payment schedule", err);
  //   }
  // };

  const addTableRows = () => {
    const newRow = {
      payment_type: "Rent",
      amount: "",
      payment_frequency: contractdetails?.payment_frequency || "Monthly",
      no_of_payments: "",
      start_date: "",
      end_date: "",
      disabled: false,
      billed: false,
    };
    setRowsData((r) => [...r, newRow]);
  };

  const deleteTableRows = (index) => {
    const rows = [...rowsData];
    rows.splice(index, 1);
    setRowsData(rows);
  };

  const handelChangeAmount = (index, value) => {
    setTermError("");
    const updated = [...rowsData];
    updated[index].amount = value;
    setRowsData(updated);
  };

 


  const handleTermChange = (index, value) => {
    const termMonths = parseInt(value);
    const updatedRowsData = [...rowsData];
    const currentType = updatedRowsData[index].payment_type;
    let startDate = new Date(contractdetails.start_date);
    let paymentstartDate = new Date(contractdetails.start_date);

    if (paymentrule === "Advance") {
      paymentstartDate = new Date(contractdetails.start_date);
    } else {
      paymentstartDate = new Date(contractdetails.paymentstartdate);
    }
    setTermError("");
    if (currentType === "Rent") {
      setTermError("");
      updatedRowsData[index].no_of_payments = value;
      if (paymentfrequency === "Monthly") {
        if (value === "") {
          updatedRowsData[index].start_date = "";
          updatedRowsData[index].end_date = "";
          updatedRowsData[index].paymentstart_date = "";

          setTermError("");
        } else if (!isNaN(termMonths) && termMonths >= 0) {
          const currentTotalTerms =
            updatedRowsData.reduce((acc, row, idx) => {
              return idx === index
                ? acc
                : acc +
                    (row.payment_type === "Rent"
                      ? parseInt(row.no_of_payments || 0)
                      : 0);
            }, 0) + termMonths;
          if (currentTotalTerms > contractdetails.contract_term) {
            setTermError(
              `Total term cannot exceed ${contractdetails.contract_term} terms.`
            );
            setRowsData(updatedRowsData);
            return;
          } else {
            setTermError("");

            if (index === 0) {
              startDate = new Date(contractdetails.start_date);
              // if(paymentrule === 'Advance'){
              //    startDate = new Date(start_date)
              //   }else{
              //     startDate = new Date(paymentstartdate)
              // }
            } else {
              for (let i = index - 1; i >= 0; i--) {
                if (updatedRowsData[i].payment_type === "Rent") {
                  let date = Helper.Dateview(updatedRowsData[i].end_date);
                  startDate = new Date(date);
                  startDate.setHours(0, 0, 0, 0);
                  startDate.setDate(startDate.getDate() + 1);

                  paymentstartDate = new Date(date);
                  paymentstartDate.setHours(0, 0, 0, 0);
                  paymentstartDate.setDate(paymentstartDate.getDate() + 1);
                  break;
                }
              }
              if (!startDate) {
                startDate = new Date(contractdetails.start_date);
                paymentstartDate = new Date(contractdetails.start_date);
              }
            }

            const endDate = new Date(startDate);
            // if(paymentrule ==="Advance"){
            //   endDate.setMonth(endDate.getMonth() + termMonths);
            // }else{
            //   if (parseInt(contract_term) === currentTotalTerms) {
            //     endDate.setMonth(endDate.getMonth() + (termMonths) - frequencyMapped.Monthly); // Set to the last day of the quarter
            //   } else {
            //     endDate.setMonth(endDate.getMonth() + (termMonths)); // Set to the last day of the quarter
            //   }
            // }
            endDate.setMonth(endDate.getMonth() + termMonths);
            endDate.setDate(endDate.getDate() - 1);

            updatedRowsData[index].start_date = Helper.DatePicker(startDate);
            updatedRowsData[index].end_date = Helper.DatePicker(endDate);
            updatedRowsData[index].paymentstart_date =
              Helper.DatePicker(paymentstartDate);
          }
        }
      } else if (paymentfrequency === "Quarterly") {
        const totalTerm =
          contractdetails.contract_term / frequencyMapped.Quarterly;
        const currentTotalTerms = updatedRowsData.reduce((acc, row) => {
          return (
            acc +
            (row.payment_type === "Rent"
              ? parseInt(row.no_of_payments || 0)
              : 0)
          );
        }, 0);
        if (currentTotalTerms > totalTerm) {
          setTermError(`Total term cannot exceed ${totalTerm} terms.`);
          setRowsData(updatedRowsData);
          return;
        } else {
          setTermError("");

          let startDate;
          let paymentstartDate;

          if (index === 0) {
            startDate = new Date(contractdetails.start_date);
            if (paymentrule === "Advance") {
              paymentstartDate = new Date(contractdetails.start_date);
            } else {
              paymentstartDate = new Date(contractdetails.paymentstartdate);
            }
          } else {
            for (let i = index - 1; i >= 0; i--) {
              if (updatedRowsData[i].payment_type === "Rent") {
                let date = Helper.Dateview(updatedRowsData[i].end_date);
                startDate = new Date(date);
                startDate.setHours(0, 0, 0, 0);
                startDate.setDate(startDate.getDate() + 1);

                paymentstartDate = new Date(date);
                paymentstartDate.setHours(0, 0, 0, 0);
                paymentstartDate.setDate(paymentstartDate.getDate() + 1);
                break;
              }
            }
            if (!startDate) {
              startDate = new Date(contractdetails.start_date);
              paymentstartDate = new Date(contractdetails.start_date);
            }
          }

          const endDate = new Date(startDate);
          const month = frequencyMapped.Quarterly * termMonths;
          // if(paymentrule==="Advance"){
          //   endDate.setMonth(endDate.getMonth() + (month)); // Set to the last day of the quarter
          // }else{
          //   if (parseInt(totalTerm) === currentTotalTerms) {
          //     endDate.setMonth(endDate.getMonth() + (month) - frequencyMapped.Quarterly); // Set to the last day of the quarter
          //   } else {
          //     endDate.setMonth(endDate.getMonth() + (month)); // Set to the last day of the quarter
          //   }
          // }
          endDate.setMonth(endDate.getMonth() + month); // Set to the last day of the quarter
          endDate.setDate(endDate.getDate() - 1);
          updatedRowsData[index].start_date = Helper.DatePicker(startDate);
          updatedRowsData[index].end_date = Helper.DatePicker(endDate);
          updatedRowsData[index].payment_frequency = "Quarterly";
          updatedRowsData[index].paymentstart_date =
            Helper.DatePicker(paymentstartDate);
        }
      } else if (paymentfrequency === "Semi-annual") {
        const totalTerm =
          contractdetails.contract_term / frequencyMapped.SemiAnnual;
        const currentTotalTerms = updatedRowsData.reduce((acc, row) => {
          return (
            acc +
            (row.payment_type === "Rent"
              ? parseInt(row.no_of_payments || 0)
              : 0)
          );
        }, 0);
        if (currentTotalTerms > totalTerm) {
          setTermError(`Total term cannot exceed ${totalTerm} terms.`);
          setRowsData(updatedRowsData);
          return;
        } else {
          setTermError("");

          let startDate;
          let paymentstartDate;

          if (index === 0) {
            startDate = new Date(contractdetails.start_date);
            if (paymentrule === "Advance") {
              paymentstartDate = new Date(contractdetails.start_date);
            } else {
              paymentstartDate = new Date(contractdetails.paymentstartdate);
            }
          } else {
            for (let i = index - 1; i >= 0; i--) {
              if (updatedRowsData[i].payment_type === "Rent") {
                let date = Helper.Dateview(updatedRowsData[i].end_date);
                startDate = new Date(date);
                startDate.setHours(0, 0, 0, 0);
                startDate.setDate(startDate.getDate() + 1);

                paymentstartDate = new Date(date);
                paymentstartDate.setHours(0, 0, 0, 0);
                paymentstartDate.setDate(paymentstartDate.getDate() + 1);
                break;
              }
            }
            if (!startDate) {
              startDate = new Date(contractdetails.start_date);
            }
          }

          const endDate = new Date(startDate);
          const month = frequencyMapped.SemiAnnual * termMonths;
          // if(paymentrule==="Advance"){
          //   endDate.setMonth(endDate.getMonth() + (month)); // Set to the last day of the quarter
          // }else{
          //   if (parseInt(totalTerm) === currentTotalTerms) {
          //     endDate.setMonth(endDate.getMonth() + (month) - frequencyMapped.SemiAnnual); // Set to the last day of the quarter
          //   } else {
          //     endDate.setMonth(endDate.getMonth() + (month)); // Set to the last day of the quarter
          //   }
          // }
          endDate.setMonth(endDate.getMonth() + month); // Set to the last day of the quarter
          endDate.setDate(endDate.getDate() - 1);
          updatedRowsData[index].start_date = Helper.DatePicker(startDate);
          updatedRowsData[index].end_date = Helper.DatePicker(endDate);
          updatedRowsData[index].payment_frequency = "Semi-annual";
          updatedRowsData[index].paymentstart_date =
            Helper.DatePicker(paymentstartDate);
        }
      } else if (paymentfrequency === "Annual") {
        const totalTerm =
          contractdetails.contract_term / frequencyMapped.Annual;
        const currentTotalTerms = updatedRowsData.reduce((acc, row) => {
          return (
            acc +
            (row.payment_type === "Rent"
              ? parseInt(row.no_of_payments || 0)
              : 0)
          );
        }, 0);
        if (currentTotalTerms > totalTerm) {
          setTermError(`Total term cannot exceed ${totalTerm} terms.`);
          setRowsData(updatedRowsData);
          return;
        } else {
          setTermError("");

          let startDate;
          if (index === 0) {
            startDate = new Date(contractdetails.start_date);
            let paymentstartDate;

            if (paymentrule === "Advance") {
              paymentstartDate = new Date(contractdetails.start_date);
            } else {
              paymentstartDate = new Date(contractdetails.paymentstartdate);
            }
          } else {
            for (let i = index - 1; i >= 0; i--) {
              if (updatedRowsData[i].payment_type === "Rent") {
                let date = Helper.Dateview(updatedRowsData[i].end_date);
                startDate = new Date(date);
                startDate.setHours(0, 0, 0, 0);
                startDate.setDate(startDate.getDate() + 1);

                paymentstartDate = new Date(date);
                paymentstartDate.setHours(0, 0, 0, 0);
                paymentstartDate.setDate(paymentstartDate.getDate() + 1);
                break;
              }
            }
            if (!startDate) {
              startDate = new Date(contractdetails.start_date);
            }
          }

          const endDate = new Date(startDate);

          const month = frequencyMapped.Annual * termMonths;
          // if(paymentrule==="Advance"){
          //   endDate.setMonth(endDate.getMonth() + (month)); // Set to the last day of the quarter
          // }else{
          //   if (parseInt(totalTerm) === currentTotalTerms) {
          //     endDate.setMonth(endDate.getMonth() + (month) - frequencyMapped.Annual); // Set to the last day of the quarter
          //   } else {
          //     endDate.setMonth(endDate.getMonth() + (month)); // Set to the last day of the quarter
          //   }
          // }
          endDate.setMonth(endDate.getMonth() + month); // Set to the last day of the quarter
          endDate.setDate(endDate.getDate() - 1);
          updatedRowsData[index].start_date = Helper.DatePicker(startDate);
          updatedRowsData[index].end_date = Helper.DatePicker(endDate);
          updatedRowsData[index].payment_frequency = "Annual";
          updatedRowsData[index].paymentstart_date =
            Helper.DatePicker(paymentstartDate);
        }
      }
      setRowsData(updatedRowsData);
    } else if (currentType === "Maintenance Fee") {
      let frequencyData;
      setTermError("");
      updatedRowsData[index].no_of_payments = value;
      frequencyData = updatedRowsData[index].payment_frequency;

      if (frequencyData === "Monthly") {
        if (value === "") {
          updatedRowsData[index].start_date = "";
          updatedRowsData[index].end_date = "";
          updatedRowsData[index].paymentstart_date = "";

          setTermError("");
        } else if (!isNaN(termMonths) && termMonths >= 0) {
          const currentTotalTerms =
            updatedRowsData.reduce((acc, row, idx) => {
              return idx === index
                ? acc
                : acc +
                    (row.payment_type === "Maintenance Fee"
                      ? parseInt(row.no_of_payments || 0)
                      : 0);
            }, 0) + termMonths;
          if (currentTotalTerms > contractdetails.contract_term) {
            setTermError(
              `Total term cannot exceed ${contractdetails.contract_term} terms.`
            );
            setRowsData(updatedRowsData);
            return;
          } else {
            setTermError("");

            if (index === 0) {
              startDate = new Date(contractdetails.start_date);
              if (paymentrule === "Advance") {
                paymentstartDate = new Date(contractdetails.start_date);
              } else {
                paymentstartDate = new Date(contractdetails.paymentstartdate);
              }
            } else {
              for (let i = index - 1; i >= 0; i--) {
                if (updatedRowsData[i].payment_type === "Maintenance Fee") {
                  let date = Helper.Dateview(updatedRowsData[i].end_date);
                  startDate = new Date(date);
                  startDate.setHours(0, 0, 0, 0);
                  startDate.setDate(startDate.getDate() + 1);

                  paymentstartDate = new Date(date);
                  paymentstartDate.setHours(0, 0, 0, 0);
                  paymentstartDate.setDate(paymentstartDate.getDate() + 1);
                  break;
                }
              }
              if (!startDate) {
                startDate = new Date(contractdetails.start_date);
              }
            }

            const endDate = new Date(startDate);
            // if(paymentrule==="Advance"){
            //   endDate.setMonth(endDate.getMonth() + (termMonths)); // Set to the last day of the quarter
            // }else{
            //   if (parseInt(contract_term) === currentTotalTerms) {
            //     endDate.setMonth(endDate.getMonth() + (termMonths) - frequencyMapped.Monthly); // Set to the last day of the quarter
            //   } else {
            //     endDate.setMonth(endDate.getMonth() + (termMonths)); // Set to the last day of the quarter
            //   }
            // }
            endDate.setMonth(endDate.getMonth() + termMonths);
            endDate.setDate(endDate.getDate() - 1);
            updatedRowsData[index].payment_frequency = "Monthly";
            updatedRowsData[index].start_date = Helper.DatePicker(startDate);
            updatedRowsData[index].end_date = Helper.DatePicker(endDate);
            updatedRowsData[index].paymentstart_date =
              Helper.DatePicker(paymentstartDate);
          }
        }
      } else if (frequencyData === "Quarterly") {
        const totalTerm =
          contractdetails.contract_term / frequencyMapped.Quarterly;
        const currentTotalTerms = updatedRowsData.reduce((acc, row) => {
          return (
            acc +
            (row.payment_type === "Maintenance Fee"
              ? parseInt(row.no_of_payments || 0)
              : 0)
          );
        }, 0);
        if (currentTotalTerms > totalTerm) {
          setTermError(`Total term cannot exceed ${totalTerm} terms.`);
          setRowsData(updatedRowsData);
          return;
        } else {
          setTermError("");

          let startDate;
          if (index === 0) {
            startDate = new Date(contractdetails.start_date);
            if (paymentrule === "Advance") {
              paymentstartDate = new Date(contractdetails.start_date);
            } else {
              paymentstartDate = new Date(contractdetails.paymentstartdate);
            }
          } else {
            for (let i = index - 1; i >= 0; i--) {
              if (updatedRowsData[i].payment_type === "Maintenance Fee") {
                let date = Helper.Dateview(updatedRowsData[i].end_date);
                startDate = new Date(date);
                startDate.setHours(0, 0, 0, 0);
                startDate.setDate(startDate.getDate() + 1);

                paymentstartDate = new Date(date);
                paymentstartDate.setHours(0, 0, 0, 0);
                paymentstartDate.setDate(paymentstartDate.getDate() + 1);
                break;
              }
            }
            if (!startDate) {
              startDate = new Date(contractdetails.start_date);
            }
          }

          const endDate = new Date(startDate);
          const month = frequencyMapped.Quarterly * termMonths;
          // if(paymentrule==="Advance"){
          //   endDate.setMonth(endDate.getMonth() + (month)); // Set to the last day of the quarter
          // }else{
          //   if (parseInt(totalTerm) === currentTotalTerms) {
          //     endDate.setMonth(endDate.getMonth() + (month) - frequencyMapped.Quarterly); // Set to the last day of the quarter
          //   } else {
          //     endDate.setMonth(endDate.getMonth() + (month)); // Set to the last day of the quarter
          //   }
          // }
          endDate.setMonth(endDate.getMonth() + month); // Set to the last day of the quarter
          endDate.setDate(endDate.getDate() - 1);
          updatedRowsData[index].start_date = Helper.DatePicker(startDate);
          updatedRowsData[index].end_date = Helper.DatePicker(endDate);
          updatedRowsData[index].payment_frequency = "Quarterly";
          updatedRowsData[index].paymentstart_date =
            Helper.DatePicker(paymentstartDate);
        }
      } else if (frequencyData === "Semi-annual") {
        const totalTerm =
          contractdetails.contract_term / frequencyMapped.SemiAnnual;
        const currentTotalTerms = updatedRowsData.reduce((acc, row) => {
          return (
            acc +
            (row.payment_type === "Maintenance Fee"
              ? parseInt(row.no_of_payments || 0)
              : 0)
          );
        }, 0);
        if (currentTotalTerms > totalTerm) {
          setTermError(`Total term cannot exceed ${totalTerm} terms.`);
          setRowsData(updatedRowsData);
          return;
        } else {
          setTermError("");

          let startDate;
          if (index === 0) {
            startDate = new Date(contractdetails.start_date);
            if (paymentrule === "Advance") {
              paymentstartDate = new Date(contractdetails.start_date);
            } else {
              paymentstartDate = new Date(contractdetails.paymentstartdate);
            }
          } else {
            for (let i = index - 1; i >= 0; i--) {
              if (updatedRowsData[i].payment_type === "Maintenance Fee") {
                let date = Helper.Dateview(updatedRowsData[i].end_date);
                startDate = new Date(date);
                startDate.setHours(0, 0, 0, 0);
                startDate.setDate(startDate.getDate() + 1);

                paymentstartDate = new Date(date);
                paymentstartDate.setHours(0, 0, 0, 0);
                paymentstartDate.setDate(paymentstartDate.getDate() + 1);
                break;
              }
            }
            if (!startDate) {
              startDate = new Date(contractdetails.start_date);
            }
          }

          const endDate = new Date(startDate);
          const month = frequencyMapped.SemiAnnual * termMonths;
          // if(paymentrule==="Advance"){
          //   endDate.setMonth(endDate.getMonth() + (month)); // Set to the last day of the quarter
          // }else{
          //   if (parseInt(totalTerm) === currentTotalTerms) {
          //     endDate.setMonth(endDate.getMonth() + (month) - frequencyMapped.SemiAnnual); // Set to the last day of the quarter
          //   } else {
          //     endDate.setMonth(endDate.getMonth() + (month)); // Set to the last day of the quarter
          //   }
          // }
          endDate.setMonth(endDate.getMonth() + month); // Set to the last day of the quarter
          endDate.setDate(endDate.getDate() - 1);
          updatedRowsData[index].start_date = Helper.DatePicker(startDate);
          updatedRowsData[index].end_date = Helper.DatePicker(endDate);
          updatedRowsData[index].payment_frequency = "Semi-annual";
          updatedRowsData[index].paymentstart_date =
            Helper.DatePicker(paymentstartDate);
        }
      } else if (frequencyData === "Annual") {
        const totalTerm =
          contractdetails.contract_term / frequencyMapped.Annual;
        const currentTotalTerms = updatedRowsData.reduce((acc, row) => {
          return (
            acc +
            (row.payment_type === "Maintenance Fee"
              ? parseInt(row.no_of_payments || 0)
              : 0)
          );
        }, 0);
        if (currentTotalTerms > totalTerm) {
          setTermError(`Total term cannot exceed ${totalTerm} terms.`);
          setRowsData(updatedRowsData);
          return;
        } else {
          setTermError("");

          let startDate;
          if (index === 0) {
            startDate = new Date(contractdetails.start_date);
            if (paymentrule === "Advance") {
              paymentstartDate = new Date(contractdetails.start_date);
            } else {
              paymentstartDate = new Date(contractdetails.paymentstartdate);
            }
          } else {
            for (let i = index - 1; i >= 0; i--) {
              if (updatedRowsData[i].payment_type === "Maintenance Fee") {
                let date = Helper.Dateview(updatedRowsData[i].end_date);
                startDate = new Date(date);
                startDate.setHours(0, 0, 0, 0);
                startDate.setDate(startDate.getDate() + 1);

                paymentstartDate = new Date(date);
                paymentstartDate.setHours(0, 0, 0, 0);
                paymentstartDate.setDate(paymentstartDate.getDate() + 1);
                break;
              }
            }
            if (!startDate) {
              startDate = new Date(contractdetails.start_date);
              //   if(paymentrule === 'Advance'){
              //     startDate = new Date(start_date)

              //    }else{

              //      startDate = new Date(paymentstartdate)
              //  }
            }
          }

          const endDate = new Date(startDate);

          const month = frequencyMapped.Annual * termMonths;
          // if(paymentrule==="Advance"){
          //   endDate.setMonth(endDate.getMonth() + (month)); // Set to the last day of the quarter
          // }else{
          //   if (parseInt(totalTerm) === currentTotalTerms) {
          //     endDate.setMonth(endDate.getMonth() + (month) - frequencyMapped.Annual); // Set to the last day of the quarter
          //   } else {
          //     endDate.setMonth(endDate.getMonth() + (month)); // Set to the last day of the quarter
          //   }
          // }
          endDate.setMonth(endDate.getMonth() + month); // Set to the last day of the quarter
          endDate.setDate(endDate.getDate() - 1);
          updatedRowsData[index].start_date = Helper.DatePicker(startDate);
          updatedRowsData[index].end_date = Helper.DatePicker(endDate);
          updatedRowsData[index].payment_frequency = "Annual";
          updatedRowsData[index].paymentstart_date =
            Helper.DatePicker(paymentstartDate);
        }
      }
      setRowsData(updatedRowsData);
    }
  };
  
  // Save: call parent onSave with only editable (unbilled) rows
  const save = () => {
   
    const payload = rowsData.map((r) => ({
      payment_type: r.payment_type || "Rent",
      no_of_payments: parseInt(r.no_of_payments, 10),
      amount: parseFloat(r.amount),
      payment_frequency: r.payment_frequency || "Monthly",
      start_date: r.start_date,
      end_date: r.end_date,
      paymentstart_date: r.paymentstart_date || r.start_date,
      periods: parseInt(r.no_of_payments, 10),
      is_historical: r.is_historical
        ? r.is_historical
        : r.billed === true
        ? true
        : false, // IMPORTANT
      version: r.version || 2,
    }));

    onSave(payload); // parent handles API call
  };


  useEffect(() => {
    if (!draftid) return;
    try {
      const responsepay = axios.get(
        `${API}contracts/paymentScheduleCalculation/?id=${draftid}`,
        {
          headers: authHeader(),
        }
      );
      responsepay.then((response) => {
        {
          setCalcSchedule(response.data.response);
        }
      });
    } catch (error) {
      console.error("Error fetching payment data:", error);
    }
  }, [rowsData, draftid]);


  useEffect(() => {
    axios
      .get(`${API}contracts/paymentDetail-view/${contractId}/`, {
        headers: authHeader(),
      })
      .then((res) => {
        setPaymentDetailsList(res.data);
      })
      .catch((err) => console.error(err));
  }, [draftid]);


  useEffect(() => {
    if (!calcSchedule.length || !paymentDetailsList.length) return;

    const merged = calcSchedule.map((sched) => {
      const matched = paymentDetailsList.find(
        (p) => p.startdate === sched.startdate && p.enddate === sched.enddate
        // p.paymenttype === sched.payment_type
      );

      // BILLED row only if date_billed present
      const isBilled = matched && matched.date_billed !== null;

      return {
        billed: isBilled,
        paymentdate: matched ? matched.paymentdate : sched.paymentdate,
        startdate: sched.startdate,
        enddate: sched.enddate,
        periodicamount: sched.periodicamount,

        // keep calculated amount but override billed amount
        amount: matched ? matched.amount : sched.periodicamount,

        payment_type: sched.payment_type,
        date_billed: isBilled ? matched.date_billed : null,
        transaction_number: isBilled ? matched.transaction_number : null,
      };
    });
   

    setMergedPaymentDetails(merged);
    // onPaymentDetailsChange(merged);
  }, [calcSchedule, paymentDetailsList]);
  const lastSentRef = useRef(null);



  useEffect(() => {
  if (!mergedPaymentDetails || mergedPaymentDetails.length === 0) return;

  const serialized = JSON.stringify(mergedPaymentDetails);

  // prevent duplicate calls
  if (lastSentRef.current === serialized) return;

  lastSentRef.current = serialized;

  if (onPaymentDetailsChange) {
    onPaymentDetailsChange(mergedPaymentDetails);
  }
}, [ onPaymentDetailsChange]);
//   useEffect(() => {
//   if (mergedPaymentDetails && mergedPaymentDetails.length > 0) {
//     onPaymentDetailsChange?.(mergedPaymentDetails);
//   }
// }, [mergedPaymentDetails]);

  return (
    <>
      <SlidingPane
        className="some-custom-class sidepanebarcontract"
        isOpen={isOpen}
        title="Edit Payment Schedule"
        onRequestClose={onClose}
      >
        <Form>
          <div className="table-responsive-sm">
            <div className="row pt-3">
              <div className="col-xl-6">
                <label className="col-form-label">{t("Payment Lines")}</label>
              </div>
              <div className="col-xl-6">
                <div className="text-right">
                  <button
                    type="button"
                    className="btn btn-outline-success"
                    onClick={addTableRows}
                  >
                    + {t("ADD")}
                  </button>
                </div>
              </div>
            </div>

            <table className="table table-nowrap mb-0">
              <thead>
                <tr>
                  <th>
                    {t("Line no.")}{" "}
                    <Tooltip content={t("LineNumber_Tooltip")}>
                      <i className="fa fa-light fa-circle-info"></i>
                    </Tooltip>
                  </th>
                  <th>
                    {t("Payment Type")}{" "}
                    <Tooltip content={t("PaymentType_Tooltip")}>
                      <i className="fa fa-light fa-circle-info"></i>
                    </Tooltip>
                  </th>
                  <th>
                    {t("Amount")}{" "}
                    <Tooltip content={t("Amount_Tooltip")}>
                      <i className="fa fa-light fa-circle-info"></i>
                    </Tooltip>
                  </th>
                  <th>
                    {t("Payment Frequency")}{" "}
                    <Tooltip content={t("PaymentType_Tooltip")}>
                      <i className="fa fa-light fa-circle-info"></i>
                    </Tooltip>
                  </th>
                  <th>
                    {t("Total Terms")}{" "}
                    <Tooltip content={t("Totalterm_Tooltip")}>
                      <i className="fa fa-light fa-circle-info"></i>
                    </Tooltip>
                  </th>
                  <th>
                    {t("Date From")}{" "}
                    <Tooltip content={t("Datefrom_Tooltip")}>
                      <i className="fa fa-light fa-circle-info"></i>
                    </Tooltip>
                  </th>
                  <th>
                    {t("Date To")}{" "}
                    <Tooltip content={t("Dateto_Tooltip")}>
                      <i className="fa fa-light fa-circle-info"></i>
                    </Tooltip>
                  </th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {rowsData.map((data, index) => (
                  <tr
                    key={index}
                    style={{ background: data.billed ? "#eaeaea" : "white" }}
                  >
                    <td>
                      <div className="d-xl-none tc d-md-none d-lg-none">
                        {t("Line no.")}{" "}
                        <Tooltip content={t("LineNumber_Tooltip")}>
                          <i className="fa fa-light fa-circle-info"></i>
                        </Tooltip>
                      </div>
                      <div>{index + 1} </div>
                    </td>
                    <td>
                      <div className="d-xl-none tc d-md-none d-lg-none">
                        {t("Payment Type")}{" "}
                        <Tooltip content={t("PaymentType_Tooltip")}>
                          <i className="fa fa-light fa-circle-info"></i>
                        </Tooltip>
                      </div>
                      <select
                        disabled={data.disabled}
                        className="form-control"
                        value={data.payment_type}
                        onChange={(evnt) =>
                          handlePaymentTypeChange(index, evnt.target.value)
                        }
                        // onChange={(e) => { const u = [...rowsData]; u[index].payment_type = e.target.value; setRowsData(u); }}
                      >
                        <option value="Rent">Payment</option>
                        {paymentType.map((p, i) => (
                          <option key={i} value={p.value}>
                            {p.label}
                          </option>
                        ))}
                      </select>
                    </td>
                    <td>
                      <div className="d-xl-none tc d-md-none d-lg-none">
                        {t("Amount")}{" "}
                        <Tooltip content={t("Amount_Tooltip")}>
                          <i className="fa fa-light fa-circle-info"></i>
                        </Tooltip>
                      </div>
                      <div>
                        <input
                          type="text"
                          disabled={data.disabled}
                          value={data.amount}
                          onChange={(e) =>
                            handelChangeAmount(index, e.target.value)
                          }
                          className="form-control"
                        />
                      </div>
                    </td>
                    <td>
                      <div className="d-xl-none tc d-md-none d-lg-none">
                        {t("Payment Type")}{" "}
                        <Tooltip content={t("PaymentType_Tooltip")}>
                          <i className="fa fa-light fa-circle-info"></i>
                        </Tooltip>
                      </div>
                      <div>
                        <select
                          disabled
                          className="form-control"
                          value={data.payment_frequency}
                          onChange={(evnt) =>
                            handlePaymentTypeChange(index, evnt.target.value)
                          }
                          //  onChange={(e) => { const u = [...rowsData]; u[index].payment_frequency = e.target.value; setRowsData(u); }}
                        >
                          {paymentFrequencystep.map((f) => (
                            <option key={f.label} value={f.label}>
                              {f.label}
                            </option>
                          ))}
                        </select>
                      </div>
                    </td>
                    <td>
                      <div className="d-xl-none tc d-md-none d-lg-none">
                        {t("Total Terms")}{" "}
                        <Tooltip content={t("Totalterm_Tooltip")}>
                          <i className="fa fa-light fa-circle-info"></i>
                        </Tooltip>
                      </div>
                      <div>
                        <input
                          type="text"
                          disabled={data.disabled}
                          value={data.no_of_payments}
                          onChange={(e) =>
                            handleTermChange(index, e.target.value)
                          }
                          className="form-control"
                        />
                      </div>
                    </td>
                    <td>
                      <div className="d-xl-none tc d-md-none d-lg-none">
                        {t("Date From")}{" "}
                        <Tooltip content={t("Datefrom_Tooltip")}>
                          <i className="fa fa-light fa-circle-info"></i>
                        </Tooltip>
                      </div>
                      <div>
                        <input
                          disabled
                          className="form-control"
                          value={Helper.Dateview(data.start_date)}
                        />
                      </div>
                    </td>
                    <td>
                      <div className="d-xl-none tc d-md-none d-lg-none">
                        {t("Date To")}{" "}
                        <Tooltip content={t("Dateto_Tooltip")}>
                          <i className="fa fa-light fa-circle-info"></i>
                        </Tooltip>
                      </div>
                      <div>
                        <input
                          disabled
                          className="form-control"
                          value={Helper.Dateview(data.end_date)}
                        />
                      </div>
                    </td>
                    <td>
                      {!data.disabled && (
                        <button
                          type="button"
                          className="btn btn-outline-danger"
                          onClick={() => deleteTableRows(index)}
                        >
                          X
                        </button>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            {termError && (
              <div className="invalid-feedback d-block">{termError}</div>
            )}
          </div>

          <div style={{ marginTop: 20 }}>
            <button
              type="button"
              className="btn btn-secondary ms-2"
              onClick={onClose}
            >
              {t("Cancel")}
            </button>
            <button
              type="button"
              className="btn btn-primary ms-2"
              onClick={save}
            >
              {t("Save")}
            </button>
          </div>
        </Form>
      </SlidingPane>
       <div className="d-lg-flex mt-3 ">
          <div>
            <h5 className="mb-0">{t("Existing Payment Schedules")}</h5>
          </div>
          </div>

      <div className="mb-3">
        <MaterialTable
          style={{
            backgroundColor: "var(--bs-table-bg)",
            borderBottomWidth: "1px",
            boxShadow: "inset 0 0 0 9999px var(--bs-table-accent-bg)",
          }}
          columns={[
            {
              title: `${t("No. Of Payments")}`,
              field: "no_of_payments",
              render: (rowDate) => (
                <>
                  <div className="d-xl-none tc d-md-none d-lg-none">
                    {t("No. Of Payments")}
                  </div>
                  <div>{rowDate.no_of_payments}</div>
                </>
              ),
              headerStyle: {
                verticalAlign: "inherit",
                fontWeight: "bold",
                textAlign: "left",
              },
              cellStyle: {
                textAlign: "left",
                fontSize: 12,
              },
            },
            {
              title: `${t("Payment Type")}`,
              field: "payment_type",
              render: (rowData) => (
                <>
                  <div className="d-xl-none tc d-md-none d-lg-none">
                    {t("Payment Type")}
                  </div>
                  <div>{rowData.payment_type === "Rent" ? "Payment" : rowData.payment_type}</div>
                </>
              ),
              headerStyle: {
                verticalAlign: "inherit",
                fontWeight: "bold",
                textAlign: "left",
              },
              cellStyle: {
                textAlign: "left",
                fontSize: 12,
              },
            },
            {
              title: `${t("Payment Amount")}`,
              field: "amount",
              render: (rowData) => (
                <>
                  <div
                    className={`d-xl-none tc d-md-none d-lg-none`}
                    style={{
                      textAlign: rowData.isSmallScreen ? "left" : "right",
                      fontSize: "12px",
                      fontWeight: rowData.isSmallScreen ? "bold" : "",
                    }}
                  >
                    {t("Payment Amount")}
                  </div>
                  <div
                    className={`d-none d-xl-block d-lg-block text-right`}
                    style={{ textAlign: "right", fontSize: "12px" }}
                  >
                    {Helper.Amount(rowData.amount)}
                  </div>
                </>
              ),
              headerStyle: {
                verticalAlign: "inherit",
                fontWeight: "bold",
                textAlign: "right",
              },
              // cellStyle: {
              //   textAlign: "right",
              //   fontSize: 12,
              // },
            },
            {
              title: `${t("Start Date")}`,
              field: "start_date",
              render: (rowData) => (
                <>
                  <div className="d-xl-none tc d-md-none d-lg-none">
                    {t("Start Date")}
                  </div>
                  <div>{Helper.DateNormal(rowData.start_date)}</div>
                </>
              ),
              headerStyle: {
                verticalAlign: "inherit",
                fontWeight: "bold",
                textAlign: "left",
              },
              cellStyle: {
                textAlign: "left",
                fontSize: 12,
              },
            },
            {
              title: `${t("End Date")}`,
              field: "end_date",
              render: (rowData) => (
                <>
                  <div className="d-xl-none tc d-md-none d-lg-none">
                    {t("End Date")}
                  </div>
                  <div>{Helper.DateNormal(rowData.end_date)}</div>
                </>
              ),
              headerStyle: {
                verticalAlign: "inherit",
                fontWeight: "bold",
                textAlign: "left",
              },
              cellStyle: {
                textAlign: "left",
                fontSize: 12,
              },
            },
          ]}
          data={itemsPayment}
          options={{
            headerStyle: {
              backgroundColor: "white",
              color: "#245C7F",
              fontSize: 12,
            },
            rowStyle: (rowData, index) => ({
              // if (index % 2) {
              //   return { backgroundColor: "#fff" };
              // }
                    // backgroundColor: rowData.is_historical || rowData.version==1 || rowData.billed
                    backgroundColor: rowData.is_historical  || rowData.billed
        ? "#f0f0f0"
        : "#ffffff",
        // opacity: rowData.is_historical || rowData.billed ? 0.6 : 1,
      pointerEvents: rowData.is_historical || rowData.billed ? "none" : "auto",
            

            }),
            sorting: true,
            search: false,
            toolbar: false,
            paging: true,
            pageSize: 3, // make initial page size
            emptyRowsWhenPaging: false, // To avoid of having empty rows
            pageSizeOptions: [3, 15, 20, 50],
            paginationType: "stepped",
            showFirstLastPageButtons: false,
            actionsColumnIndex: -1,
          }}
        />
      </div>
       <div className="d-lg-flex mt-3 ">
          <div>
            <h5 className="mb-0">{t("New Payment Schedules")}</h5>
          </div>
          </div>

      <div className="mb-3">
        <MaterialTable
          style={{
            backgroundColor: "var(--bs-table-bg)",
            borderBottomWidth: "1px",
            boxShadow: "inset 0 0 0 9999px var(--bs-table-accent-bg)",
          }}
          columns={[
            {
              title: `${t("No. Of Payments")}`,
              field: "no_of_payments",
              render: (rowDate) => (
                <>
                  <div className="d-xl-none tc d-md-none d-lg-none">
                    {t("No. Of Payments")}
                  </div>
                  <div>{rowDate.no_of_payments}</div>
                </>
              ),
              headerStyle: {
                verticalAlign: "inherit",
                fontWeight: "bold",
                textAlign: "left",
              },
              cellStyle: {
                textAlign: "left",
                fontSize: 12,
              },
            },
            {
              title: `${t("Payment Type")}`,
              field: "payment_type",
              render: (rowData) => (
                <>
                  <div className="d-xl-none tc d-md-none d-lg-none">
                    {t("Payment Type")}
                  </div>
                  <div>{rowData.payment_type === "Rent" ? "Payment" : rowData.payment_type}</div>
                </>
              ),
              headerStyle: {
                verticalAlign: "inherit",
                fontWeight: "bold",
                textAlign: "left",
              },
              cellStyle: {
                textAlign: "left",
                fontSize: 12,
              },
            },
            {
              title: `${t("Payment Amount")}`,
              field: "amount",
              render: (rowData) => (
                <>
                  <div
                    className={`d-xl-none tc d-md-none d-lg-none`}
                    style={{
                      textAlign: rowData.isSmallScreen ? "left" : "right",
                      fontSize: "12px",
                      fontWeight: rowData.isSmallScreen ? "bold" : "",
                    }}
                  >
                    {t("Payment Amount")}
                  </div>
                  <div
                    className={`d-none d-xl-block d-lg-block text-right`}
                    style={{ textAlign: "right", fontSize: "12px" }}
                  >
                    {Helper.Amount(rowData.amount)}
                  </div>
                </>
              ),
              headerStyle: {
                verticalAlign: "inherit",
                fontWeight: "bold",
                textAlign: "right",
              },
              // cellStyle: {
              //   textAlign: "right",
              //   fontSize: 12,
              // },
            },
            {
              title: `${t("Start Date")}`,
              field: "start_date",
              render: (rowData) => (
                <>
                  <div className="d-xl-none tc d-md-none d-lg-none">
                    {t("Start Date")}
                  </div>
                  <div>{Helper.DateNormal(rowData.start_date)}</div>
                </>
              ),
              headerStyle: {
                verticalAlign: "inherit",
                fontWeight: "bold",
                textAlign: "left",
              },
              cellStyle: {
                textAlign: "left",
                fontSize: 12,
              },
            },
            {
              title: `${t("End Date")}`,
              field: "end_date",
              render: (rowData) => (
                <>
                  <div className="d-xl-none tc d-md-none d-lg-none">
                    {t("End Date")}
                  </div>
                  <div>{Helper.DateNormal(rowData.end_date)}</div>
                </>
              ),
              headerStyle: {
                verticalAlign: "inherit",
                fontWeight: "bold",
                textAlign: "left",
              },
              cellStyle: {
                textAlign: "left",
                fontSize: 12,
              },
            },
          ]}
          data={itemsPaymentParent}
          options={{
            headerStyle: {
              backgroundColor: "white",
              color: "#245C7F",
              fontSize: 12,
            },
            rowStyle: (rowData, index) => ({
              // if (index % 2) {
              //   return { backgroundColor: "#fff" };
              // }
                    // backgroundColor: rowData.is_historical || rowData.version==1 || rowData.billed
                    backgroundColor: rowData.is_historical  || rowData.billed
        ? "#f0f0f0"
        : "#ffffff",
        // opacity: rowData.is_historical || rowData.billed ? 0.6 : 1,
      pointerEvents: rowData.is_historical || rowData.billed ? "none" : "auto",
            

            }),
            sorting: true,
            search: false,
            toolbar: false,
            paging: true,
            pageSize: 3, // make initial page size
            emptyRowsWhenPaging: false, // To avoid of having empty rows
            pageSizeOptions: [3, 15, 20, 50],
            paginationType: "stepped",
            showFirstLastPageButtons: false,
            actionsColumnIndex: -1,
          }}
        />
      </div>

      <ContractPaymentDetails
        contractDate={contractdetails.start_date}
        paymentRule={paymentrule}
        paymentFrequency={paymentfrequency}
        noTerms={contractdetails.contract_term}
        items={rowsData}
        contract_type={contractdetails.contract_type}
        paymentdetails={mergedPaymentDetails} // ★ THIS SHOWS THE UPDATED PAYMENT DETAILS
      />
    </>
  );
}
